module.exports = __webpack_public_path__ + "static/img/act-steps-m-1.6f1a056.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/act-steps-m-1.png
// module id = Dk5z
// module chunks = 1